import filters from './filters/'
import prototype from './prototype/'
import components from './components/'

export default {
  install(Vue) {
    Object.keys(prototype).forEach(key => {
      Vue.prototype[`$${key}`] = prototype[key]
    })

    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })

    Object.keys(components).forEach(key => {
      Vue.component(key, components[key])
    })
  }
}
